import React, { useEffect, useState } from 'react';

import { Button, Popover, Space, Typography } from 'antd';
import { EditFilled, UpOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
const { Text } = Typography;

import * as calendarConsts from './../../../constants/calendar-constants';

import './custom-header.less';
import './custom-sizes.less';
import HeadEvent from '../custom-events/head-event';

const CustomHeader = (props) => {
  const { rootContainer, headEvents, onEditEvent, onAddEvent, onDeleteEvent, days, calendarCategories, settings, onToggleEvents } = props;

  const [showAllEvents, setShowAllEvents] = useState(true);

  useEffect(() => {
    if (settings && settings.showAllEvents) {
      setShowAllEvents(settings.showAllEvents);
    }
  }, [settings]);

  const toogleHeadEvents = (domEvent) => {
    setShowAllEvents(!showAllEvents); // todo: check hooks later

    // onToggleEvents(domEvent);
  };

  let modeClass = '';

  if (days) {
    switch (days.length) {
      case calendarConsts.WeekModeDays:
        modeClass = 'week-column';
        break;
      case calendarConsts.DayModeDays:
        modeClass = 'single-column';
        break;
      case calendarConsts.TimelineModeDays:
        modeClass = 'timeline-column';
        break;
    }
  }

  const eventsToShow = 2;

  return (
    <div className="calendar-custom-mode-head bottom-bordered">
      <div className="calendar-custom-mode-events-toggler left-pane right-bordered">
        {headEvents && headEvents.length >= eventsToShow ? (
          <Button
            title={showAllEvents ? 'Hide latest' : 'Show all'}
            className={!headEvents && 'hidden'}
            type="default"
            shape="circle"
            // size="small"
            icon={showAllEvents ? <UpOutlined className="calendar-scheduler-icon-btn" /> : <DownOutlined className="calendar-scheduler-icon-btn" />}
            onClick={($event) => toogleHeadEvents($event)}
          />
        ) : null}
        {days && days.length > 0 ? (
          <Button
            title={'Add new event'}
            type="default"
            shape="circle"
            // size="small"
            icon={<PlusOutlined className="calendar-scheduler-icon-btn" />}
            onClick={($event) => onAddEvent($event, days[0].dateObjStart, 8 * 60)}
          />
        ) : null}
      </div>

      <div className="calendar-custom-mode-header-events right-pane">
        {days ? (
          <>
            <div className="custom-mode-head-days">
              {days.map((day) => (
                <div key={'head-of-' + day.day} className={['custom-mode-head-day', modeClass, day.selected ? 'selected-day' : ''].join(' ')}>
                  <Text className="head-day">{day.day}</Text>
                  <Text className="head-date">{day.date}</Text>
                </div>
              ))}
            </div>

            <div className="head-events">
              {headEvents &&
                headEvents
                  .filter((ev, evIndex) => showAllEvents || (!showAllEvents && evIndex < eventsToShow))
                  .map((item) => (
                    <HeadEvent
                      key={item.id}
                      item={item}
                      onEditEvent={onEditEvent}
                      onDeleteEvent={onDeleteEvent}
                      daysCount={days && days.length}
                      rootContainer={rootContainer}
                      calendarCategories={calendarCategories}
                    />
                  ))}
            </div>
            <div className="head-events-days">
              {headEvents &&
                days.map((day, index) => (
                  <div
                    key={'borders' + day.day}
                    style={{
                      left: `calc(${100 * index}%/${days.length})`,
                      height: headEvents.length * 30 + 'px',
                    }}
                    className={['head-event-borders', modeClass, 'right-bordered'].join(' ')}
                  ></div>
                ))}
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default CustomHeader;
